import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { formatRelative } from 'date-fns';
import { enAU } from 'date-fns/locale';
import { useState } from 'react';
import { WorksheetHistoryResult } from '../../../types/worksheet';
import WorksheetHistoryRow from './WorksheetHistoryRow';

// Override date-fns's locale settings to remove the time
const formatRelativeLocale = {
    lastWeek: "'last' eeee",
    yesterday: "'yesterday'",
    today: "'today'",
    tomorrow: "'tomorrow'",
    nextWeek: 'eeee',
    other: 'P',
};

const locale = { ...enAU, formatRelative: (t: keyof typeof formatRelativeLocale) => formatRelativeLocale[t] };

type WorksheetHistoryDateProps = {
    date: string;
    events: WorksheetHistoryResult[];
    defaultCollapsed: boolean;
};

function WorksheetHistoryDate({ date, events, defaultCollapsed }: WorksheetHistoryDateProps): JSX.Element {
    const [collapsed, setCollapsed] = useState(defaultCollapsed);

    const title = formatRelative(new Date(date), new Date(), { locale });

    return (
        <div>
            <button className="text-gray-800 font-medium capitalize flex items-center gap-1" onClick={(): void => setCollapsed(!collapsed)}>
                <ChevronDownIcon className={`h-4 w-4 ${collapsed ? '-rotate-90' : ''}`} /> {title} ({events.length})
            </button>
            {!collapsed && (
                <div className="pl-2 mt-2">
                    {events
                        .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))
                        .map((record, idx) => {
                            return (
                                <div className="relative " key={record.id}>
                                    <WorksheetHistoryRow record={record} />
                                    {idx !== events.length - 1 && <div className="my-1 ml-2.5 h-4 w-0.5 bg-gray-200" />}
                                </div>
                            );
                        })}
                </div>
            )}
        </div>
    );
}

export default WorksheetHistoryDate;
